import React from 'react';
import { Col } from 'reactstrap';
import ReportQuestion from '../../Components-2025/QuestionBank/ReportQuestion';
import SaveQuestion from '../../Components-2025/QuestionBank/SaveQuestion';
import NotesStats from './NotesStats';
function NotesCardFooter({
  toggleReportSection,
  favItemId,
  onSaveItemChange,
  setChildRef,
  apiServiceProvider,
  savePayLoad,
  isLoading = true,
  level,
}) {
  return (
    !isLoading && (
      <Col sm={9} xs={12}>
        <div className='d-flex align-items-center mt-2 mb-1'>
          <NotesStats apiServiceProvider={apiServiceProvider} id={favItemId} level={level} />
          <SaveQuestion
            savePayLoad={savePayLoad}
            favItemId={favItemId}
            onSaveItemChange={onSaveItemChange}
            setChildRef={setChildRef}
            apiServiceProvider={apiServiceProvider}
          />
          <ReportQuestion onClick={toggleReportSection} />
        </div>
      </Col>
    )
  );
}
export default NotesCardFooter;



// WEBPACK FOOTER //
// ./src/Components-2025/Notes/CardFooter.jsx